<template>
    <div>
        <div @click="showAdd = !showAdd">
            <slot name="activator"></slot>
        </div>

        <app-input-dlg
                :show-dialog="showAdd"
                title="Add Folder Group"
                :cancel-button="true"
                :show-input-box="false"
                @dismiss="showAdd = false"
                :body-padding="false"
        >
            <template slot="body">
                <div class="px-1 pt-1">
                    <div :class="topicClass">
                        <div :class="headingClass">
                            Select Folder Group:
                        </div>
                    </div>
                    <v-text-field
                            label="Filter Folder Groups"
                            single-line
                            color="primary"
                            hide-details
                            style="width: 100%"
                            class="pa-0 ma-0"
                            ref="WFGroupFilter"
                            v-model="folderGroupFilterString"
                            prepend-inner-icon="search"
                    />
                    <div class="scrollable" style="height: 300px">
                        <div v-for="item in filteredSelectedFolderGroups" :key="item.id" >
                            <div
                                    class="hover-item"
                                    :class="selectedFolderGroup != null && selectedFolderGroup.id == item.id ? 'grey lighten-3' : ''"
                            >
                                <v-layout row align-center style="overflow-x: hidden" class="hide-parent">
                                    <v-flex xs12 style="overflow-x: hidden" class="pa-2" @click="selectedFolderGroup = item">
                                        <div class="body-1" :class="selectedFolderGroup != null && selectedFolderGroup.id == item.id ? 'primary--text' : ''">
                                            {{item.description}}
                                        </div>
                                        <div class="caption text-truncate" :class="Array.isArray(item.members) ? 'greyType--text' : 'red--text'" style="overflow-x: hidden">
                                            {{Array.isArray(item.members) ? item.members.map(obj => {return obj.description}).join(', ') : 'NO USER GROUPS ASSIGNED'}}
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-divider/>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="actions">
                <div class="text-xs-right">
                    <v-btn
                            small
                            color="secondary"
                            :disabled="selectedFolderGroup == null || addingFolderGroup"
                            :loading="addingFolderGroup"
                            @click="addFolderGroup"
                    >
                        Add Folder Group
                    </v-btn>
                </div>
            </template>
        </app-input-dlg>
    </div>
</template>

<script>
    import {codeBaseMixin} from "../../../codeBaseMixin";
    import InputDlg from "../../../components/General/InputDlg";

    export default {
        components: {
            appInputDlg: InputDlg
        },
        mixins: [codeBaseMixin],
        props: {
            userInfo: Object,
            selectedFolder: Object,
            folderGroups: Array,
        },
        data() {
            return {
                showAdd: false,
                folderGroupFilterString: null,
                selectedFolderGroup: null,
                addingFolderGroup: false,
            }
        },
        watch: {
            showAdd(shown) {
                if (shown) {
                    this.folderGroupFilterString = null;
                    this.selectedFolderGroup = null;
                    this.addingFolderGroup = false;
                    this.$nextTick(() => {
                        this.$refs.WFGroupFilter.focus();
                    })
                }
            },
        },
        methods: {
            addFolderGroup() {
                this.addingFolderGroup = true;
                this.fetch({method: 'POST', url:`/folderManager/security/folderGroup/addMember/${this.userInfo.entityID}/${this.selectedFolder.id}/${this.selectedFolderGroup.id}`})
                    .then(() => {
                        this.$emit('folderGroupAdded', this.selectedFolderGroup);
                        this.showAdd = false;
                        this.addingFolderGroup = false;
                        this.showSnack('Info', 'Folder Group Added', 'Close', 'primary')
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.addingFolderGroup = false;
                    })
            }
        },
        computed: {
            filteredSelectedFolderGroups() {
                    return this.blankString(this.folderGroupFilterString)
                        ? this.folderGroups.filter(obj => true)
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1)
                        : this.folderGroups
                            .reduce((list, folderGroup) => {
                                if (
                                    [folderGroup.description].concat(
                                        !Array.isArray(folderGroup.members)
                                            ? null
                                            : folderGroup.members.map(userGroup => {
                                                return [userGroup.description].concat(
                                                    userGroup.members.map(user => {
                                                        return typeof user != 'undefined' ? user.description : null
                                                    }).join(', ')
                                                ).join(', ')
                                            }).join(', ')
                                    ).join(', ').toLowerCase().includes(this.folderGroupFilterString.toLowerCase())
                                ) {
                                    list.push(folderGroup)
                                }
                                return list
                            }, [])
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1);

            },
        }

    }
</script>

<style scoped>

</style>
